module.exports = __webpack_public_path__ + "img/borderLargeBracesWhite.9ed03117.svg";